import { defineMessages } from 'react-intl-next';

export const i18n: {
	campaignStatusFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	campaignStatusFilterNoOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	campaignStatusFilterLabel: {
		id: 'search-page.salesforce.filter.campaignStatus',
		defaultMessage: 'Campaign status',
		description: 'Label for filtering by Salesforce campaign status',
	},
	campaignStatusFilterNoOptions: {
		id: 'search-page.salesforce.filter.campaignStatus.no-options',
		defaultMessage: 'No statuses available',
		description:
			'Message shown in the Salesforce campaign status filter dropdown when no status options are available',
	},
});
